var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0769 3.81875H10.9231C9.53846 3.81875 8.38461 5.0375 8.38461 6.5V6.58125C8.38461 8.04375 9.53846 9.2625 10.9231 9.2625H12.3077V9.75C12.3077 10.725 11.6154 11.4563 10.8462 11.4563H3C2.23077 11.375 1.53846 10.6437 1.53846 9.66875V3.33125C1.53846 2.35625 2.23077 1.625 3 1.625H10.8462C11.3846 1.625 11.9231 1.95 12.1538 2.6C12.3077 3.00625 12.7692 3.16875 13.1538 3.00625C13.5385 2.84375 13.6923 2.35625 13.5385 1.95C13.0769 0.73125 12 0 10.8462 0H3C1.38462 0 0 1.4625 0 3.33125V9.66875C0 11.5375 1.38462 13 3 13H10.8462C12.5385 13 13.8462 11.5375 13.8462 9.66875V9.01875C14.5385 8.69375 15 7.9625 15 7.15V5.85C15 4.7125 14.1538 3.81875 13.0769 3.81875ZM9.92308 6.58125V6.41875C9.92308 5.85 10.3846 5.3625 10.9231 5.3625H13.0769C13.3077 5.3625 13.4615 5.525 13.4615 5.76875V7.15C13.4615 7.39375 13.3077 7.55625 13.0769 7.55625H10.9231C10.3846 7.55625 9.92308 7.15 9.92308 6.58125Z",
    fill: "#EB1E4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.7ce397286f44c1d98d6d83656454923a.svg";
export { ForwardRef as ReactComponent };